import { XIcon } from 'lucide-react';

import { Coupon } from '@app-types/coupon.type';

import styles from './selected-coupon.module.scss';

type Props = {
    coupon: Coupon;
    onRemove: () => void;
};

const SelectedCoupon = ({ coupon, onRemove }: Props) => (
    <div className={styles.row}>
        <div className={styles.content}>
            <div className={styles.col}>
                <label>Código</label>
                <span>{coupon.code}</span>
            </div>
            <div className={styles.col}>
                <label>Descuento</label>
                <span>-{coupon.discount}%</span>
            </div>
        </div>
        <div className={styles.removeIcon} onClick={onRemove}>
            <XIcon size={18} />
        </div>
    </div>
);

export { SelectedCoupon };
